var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 14.02,
    height: 14.034,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.8 11.24a1.4 1.4 0 0 0-1.4 1.4.7.7 0 1 1-1.4 0 2.8 2.8 0 0 1 2.8-2.8h8.81L17 8.23a.707.707 0 1 1 1-1L20.8 10a.7.7 0 0 1 0 1L18 13.83a.707.707 0 0 1-1-1l1.62-1.61zm-.41 5.6h8.81a1.4 1.4 0 0 0 1.4-1.4.7.7 0 0 1 1.4 0 2.8 2.8 0 0 1-2.8 2.8H9.39L11 19.85a.707.707 0 0 1-1 1L7.2 18a.7.7 0 0 1 0-1l2.8-2.8a.707.707 0 1 1 1 1l-1.62 1.64z",
    id: "path4",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "rect7",
    style: {
      fill: "none"
    },
    d: "M4.2 4.2h20v20h-20z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    id: "g18",
    transform: "translate(-6.99 -7.023)",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)",
    id: "g16",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect14",
    style: {
      fill: "#303752",
      fillOpacity: 1
    },
    d: "M2 2h24v24H2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionSquare);
export default __webpack_public_path__ + "static/media/connection-square.4f3f25a29af0813c969b33f56709bea5.svg";
export { ForwardRef as ReactComponent };